import("../src/javascripts/navigation");
import("../src/javascripts/easy-toggle");
import("../src/javascripts/tabs");
import("../src/javascripts/slider_splide");

// script for form attachment inputs in contact form
import("../src/javascripts/attachments-redesign");
import("../src/javascripts/smooth-scroll-to-anchor");
